module.exports = __webpack_public_path__ + "img/sc-4.beb27774.png";